// extracted by mini-css-extract-plugin
module.exports = {"attributionBox":"r"};